var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4695 5C13.4695 2.79086 11.6786 1 9.46945 1C7.26031 1 5.46945 2.79086 5.46945 5M6.46945 15C8.8256 16.3404 10.117 16.3263 12.4695 15M5.00059 21H13.9383C16.3443 21 18.2059 18.8913 17.9074 16.5039L16.9074 8.50386C16.6572 6.50215 14.9556 5 12.9383 5H6.00059C3.9833 5 2.28169 6.50215 2.03148 8.50386L1.03148 16.5039C0.733051 18.8913 2.5946 21 5.00059 21Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.6b4dc3f5320428b9db7d3b10449247b7.svg";
export { ForwardRef as ReactComponent };